/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Button, Link, styled, TextField, Typography } from "@mui/material";

export const StyledBreadCrumbContainer = styled("div")({
  height: "20px",
  width: "100%",
  backgroundColor: "#f5f5f8",
  padding: "10px 0px 10px 20px",
  borderColor: "#e0e0e0",
  borderWidth: "0px 0px 1px 0px",
  borderStyle: "solid",
});

export const StyledLink = styled(Link)(({ color }) => ({
  textDecoration: "none",
  color: color,
  fontSize: "13px",
  fontWeight: "400",
}));

export const StyledHeaderRow = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const StyledTitleContainer = styled("div")({
  padding: "20px 0px 10px 0px",
});

export const StyledTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: "700",
  lineHeight: "40px",
});

export const StyledSearchBar = styled(TextField)({
  width: "280px",
  "&:hover": {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #2b4fb9 !important",
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: "25px",
  },
});

export const StyledCreateButton = styled(Button)({
  textTransform: "none",
  fontWeight: "600",
  boxShadow: "none",
});

export const StyledActionsContainer = styled("div")({
  display: "flex",
  alignItems: "center",
});

export const StyledDialogTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: "600",
  color: "#18181b",
  padding: "20px 24px 0px 24px",
});

export const StyledDialogBody = styled(Typography)({
  fontSize: "14px",
  fontWeight: "400",
  color: "#3f3f46",
  padding: "12px 24px 0px 24px",
});
